import script from "./AddFormula.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFormula.vue?vue&type=script&setup=true&lang=js"

import "./AddFormula.vue?vue&type=style&index=0&id=9dc38354&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dc38354"]])

export default __exports__